// Restaurant context for managing selected restaurant
import { createContext, useContext, useState, useEffect, ReactNode } from 'react'
import { useCurrentUser } from '@/hooks/useAuth'
import { useCurrentAssistant } from '@/hooks/useAssistantAuth'

interface RestaurantContextType {
  selectedRestaurantId: string | null
  setSelectedRestaurantId: (id: string | null) => void
}

const RestaurantContext = createContext<RestaurantContextType | undefined>(
  undefined
)

export function RestaurantProvider({ children }: { children: ReactNode }) {
  const { data: user } = useCurrentUser()
  const { data: assistant } = useCurrentAssistant()
  const [selectedRestaurantId, setSelectedRestaurantId] = useState<string | null>(null)

  // Automatically set restaurant ID from logged-in user or assistant
  useEffect(() => {
    if (user?.restaurantId) {
      setSelectedRestaurantId(user.restaurantId)
    } else if (assistant?.restaurantId) {
      setSelectedRestaurantId(assistant.restaurantId)
    }
  }, [user, assistant])

  return (
    <RestaurantContext.Provider
      value={{ selectedRestaurantId, setSelectedRestaurantId }}
    >
      {children}
    </RestaurantContext.Provider>
  )
}

export function useRestaurantContext() {
  const context = useContext(RestaurantContext)
  if (context === undefined) {
    throw new Error(
      'useRestaurantContext must be used within a RestaurantProvider'
    )
  }
  return context
}
